/**
 * 增强模式(步骤)
 */

import React, { useEffect, useMemo, useState } from 'react';
import { observer, useLocalObservable } from 'mobx-react-lite';
import { HelperCore, HelpOther } from '@/common/helper';
import { SVGPureIcon } from '@/ui';
import KnowledgeEnhanceStore from './store';
import globalStore from '@/store/global';
import './index.scss';
import client from '@/store/client';
import Loader from '@/common/helper/loader';
import { KNOWLEDGE_REFERER } from '@/components/input-file/shared';
import { message } from 'antd';
import { useConversationContext } from '../context';

const KnowledgeEnhance = observer(props => {
  const {
    folded = false,
    messageItem,
  } = props;
  const user_knowledge = messageItem.user_knowledge || [];
  const {
    conversationId,
  } = useConversationContext();

  const store = useLocalObservable(() => new KnowledgeEnhanceStore(conversationId));
  useEffect(() => {
    store.updateData({ isFolded: folded });
  }, [folded]);

  if(!user_knowledge.length){
    return null;
  }

  return (
    <div className={`flex flex-col`}>
      <div
        className={`${store.isFolded ? '' : 'mb-8px'}`}
      >
        <div
          className={`inline-flex items-center cursor-pointer rounded-12px pl-[10px] pr-[16px] py-[7px] relative hover:bg-gray-nav-hover ${globalStore.isDark ? 'bg-[#31313A]' : 'bg-[rgba(0,0,0,0.03)]'}`}
          onClick={() => {
            store.toggleFolded();
          }}
        >
          <div className="h-18px text-[13px] leading-18px text-primary flex items-center relative">
            <SVGPureIcon
              className="w-[18px] h-[18px]"
              name="knowledge"
            ></SVGPureIcon>
            <div className='ml-6px mr-8px'>{`已在知识库中检索到${user_knowledge.length}篇资料作为参考`}</div>
            <div
              className={`size-16px flex items-center justify-center cursor-pointer transition-transform transition-[0.25s] transform ${!store.isFolded ? '' : 'rotate-[180deg]'}`}
              onClick={event => {
                event.stopPropagation();
                store.toggleFolded();
              }}
            >
              <SVGPureIcon
                className="w-[10px] h-[6px]"
                name="ds_fold"
              ></SVGPureIcon>
            </div>
          </div>
        </div>
      </div>
      <div
        className={`flex flex-col border-1px border-black border-opacity-10 py-4px rounded-12px w-max max-w-full bg-white px-4px ${store.isFolded ? 'hidden' : ''}`}
      >
        {
          user_knowledge.map((item, index) => {
            const config = KNOWLEDGE_REFERER[HelperCore.getFileNameExt(item.file_name).toLowerCase()] || KNOWLEDGE_REFERER.others;
            const text = config.text || HelperCore.getFileNameExt(item.file_name).toUpperCase()
            return (
              <div
                key={item.file_id}
                className="h-32px px-12px rounded-12px bg-white truncate text-13px leading-32px cursor-pointer select-none w-max max-w-full hover:bg-black hover:bg-opacity-3"
                onClick={
                  async () => {
                    // if(store.isOpening){
                    //   return;
                    // }
                    // store.setOpening(true);

                    // if(!item.ks_id){
                    //   const knowledegeInfo = await Loader.getKnowledgeInfo(item.folder_id);
                    //   if(knowledegeInfo){
                    //     item.ks_id = knowledegeInfo.ks_id;
                    //   }
                    // }
                    // let url = Loader.getFilePriviewUrl(item);
                    // if (store.supportPreviewByEyun(item.file_name)) {
                    //   const result = await store.openWithWSCloud(item)
                    //   if (result) {
                    //     if(result === true){
                    //       store.setOpening(false);
                    //       return;
                    //     }
                    //     if(result.errmsg){
                    //       HelpOther.toast(result.errmsg, "error");
                    //       store.setOpening(false);
                    //       return;
                    //     }
                    //     else {
                    //       url = result.downloadUrl;
                    //     }
                    //   }
                    // }
                    // else if (store.supportPreviewByWeishi(item.file_name)) {
                    //   const hasPermission = await store.checkPermission(item.folder_id);
                    //   if(!hasPermission){
                    //     HelpOther.toast(Loader.previewPromissionMsg, "error");
                    //     store.setOpening(false);
                    //     return;
                    //   }
                    //   url = Loader.getFilePriviewUrl(item);
                    // }
                    // else {
                    //   message.error("暂不支持该格式的文件预览");
                    //   store.setOpening(false);
                    //   return;
                    // }

                    // store.setOpening(false);
                    // if (client.isLLQ) {
                    //   client.openPage(url);
                    // } else if (client.isClient) {
                    //   client.run("OpenUrl", null, url);
                    // } else {
                    //   window.open(url);
                    // }
                  }
                }>
                <span className={`!border-1px !border-solid rounded-full px-4px py-2px mr-4px whitespace-nowrap inline-block text-12px font-bold-600 w-max select-none transform scale-90 origin-left`}
                  style={{
                    color : config.color,
                    borderColor : config.color,
                  }}
                >
                  {index + 1}
                  <span
                    className="opacity-30 mx-2px w-1px h-8px inline-block"
                    style={{
                      background: config.color,
                    }}
                    >
                  </span>
                  {text}
                </span>
                {item.file_name}
              </div>
            )
          })
        }
      </div>
    </div>
  );
});
export default KnowledgeEnhance;
